"use client";

import type { FormProps } from "@/components/form/Form.js";
import { Form } from "@/components/form/Form.js";
import { RosetteGamesBanner } from "@/components/social/banner/RosetteGamesBanner.js";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "@rosette/web_components/src/ui/Card.js";
import type { ArticleDirPiece } from "@/components/articles/ArticleDir.js";
import ArticleDir from "@/components/articles/ArticleDir.js";


interface RosetteTitleSectionProps {
    title: string;
}


export function RosetteTitleSection({ title }: RosetteTitleSectionProps) {
    return (
        <div className="w-full text-center">
            <RosetteGamesBanner />

            {title && (
                <h1 className="mt-6 mb-6 text-2xl font-medium">
                    {title}
                </h1>
            )}
        </div>
    );
}


interface RosetteFormContentProps {
    children: ReactNode;
    title: string;
}


function RosetteFormContent({ children, title }: RosetteFormContentProps) {
    return (
        <>
            <RosetteTitleSection title={title} />

            {children}
        </>
    );
}


export interface RosetteFormProps extends FormProps {
    children?: ReactNode;
    title: string;
    backPieces?: ArticleDirPiece[];
}


export function RosetteForm({
    children, title, backPieces,
    ...props
}: RosetteFormProps) {

    return (
        <>
            {backPieces && (
                <div className="mb-4">
                    <ArticleDir dir={backPieces} />
                </div>
            )}
            <Card className="mb-14 max-w-lg">
                <Form {...props}>
                    <RosetteFormContent title={title}>
                        {children}
                    </RosetteFormContent>
                </Form>
            </Card>
        </>
    );
}
